import { render, staticRenderFns } from "./UserProfileProp.vue?vue&type=template&id=da297796&scoped=true&"
import script from "./UserProfileProp.vue?vue&type=script&lang=js&"
export * from "./UserProfileProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da297796",
  null
  
)

export default component.exports